import distributorConstants from "../constants/distributorConstants";

export const getDistributors = (payload: any) => ({
  type: distributorConstants.GET_DISTRIBUTORS_REQUEST,
  payload,
});

export const createDistributor = (payload: any) => ({
  type: distributorConstants.CREATE_DISTRIBUTOR_REQUEST,
  payload,
});

export const editDistributor = (id: string, payload: any) => ({
  type: distributorConstants.EDIT_DISTRIBUTOR_REQUEST,
  id,
  payload,
});

export const resetDistributor = () => ({
  type: distributorConstants.RESET_DISTRIBUTOR_REQUEST,
});

export const resetDistributorList = () => ({
  type: distributorConstants.RESET_DISTRIBUTOR_LIST,
});
